<template>
	<div class="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex items-center justify-center z-40 p-4" @click.self="$emit('close')">
		<div class="popup-bg rounded-xl shadow-2xl w-full max-w-md p-8 relative animate-scale-in" @click.stop>
			<!-- Close button -->
			<button @click="$emit('close')" class="absolute top-4 right-4 p-2 rounded-full hover:bg-[var(--hover-bg-color)] transition">
				<img :src="currentTheme==='dark'||currentTheme==='navy' ? darkX : lightX" alt="Close" class="w-4 h-4"/>
			</button>

			<h1 class="text-2xl font-archivomedium text-center text-[var(--text-color)] my-4 px-2">
				Choose Withdrawal Address
			</h1>

			<div class="mb-4 p-4 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-800 rounded">
				<strong>⚠️ This cannot be undone.</strong><br/>
				This will be your permanent withdrawal address.
			</div>

			<!-- Dropdown -->
			<div class="relative my-6">
				<button @click="toggle" class="w-full px-4 py-2 rounded-lg bg-[var(--popup-bg-color)] flex justify-between items-center text-sm text-[var(--text-color)]">
					<span>
						{{ selected ? `${selected.name} – ${abbr(selected.address)}` : 'Select Account' }}
					</span>
					<span>
						<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" :class="['w-6 h-6 transform transition-transform', open ? 'rotate-180' : '', (currentTheme === 'dark' || currentTheme === 'navy') ? 'text-white' : 'text-gray-700']">
							<path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7"/>
						</svg>
					</span>
				</button>

				<transition name="fade">
					<div v-if="open" class="absolute mt-1 w-full bg-[var(--dropdown-bg-color)] text-[var(--text-color)] border border-[var(--border-color)] rounded-lg shadow-lg z-10 max-h-60 overflow-y-auto">
						<button v-for="(a,i) in evmAccounts" :key="i" @click="select(a)" class="w-full text-left text-sm px-4 py-3 font-archivolight hover:bg-[var(--accent-color)] rounded-lg transition duration-200">
							{{ a.name }} – {{ a.address }}
						</button>
						<div class="border-t border-[var(--border-color)]">
							<button @click="add" class="w-full px-4 py-3 flex items-center space-x-2 text-[var(--accent-color)] rounded-lg hover:text-white hover:bg-[var(--accent-color)] transition duration-200">
								<img :src="currentTheme==='dark'||currentTheme==='navy' ? plusDark : plusLight" alt="+" class="w-4 h-4" />
								<span>
									Add Account
								</span>
							</button>
						</div>
					</div>
				</transition>
			</div>

			<!-- Confirm -->
			<button @click="$emit('confirm-withdrawal-address', selected)" :disabled="!selected" class="w-full py-2 rounded-full bg-[var(--accent-color)] text-white font-archivamedium border border-[var(--accent-color)] hover:bg-transparent hover:text-[var(--accent-color)] transition duration-200 disabled:opacity-50 disabled:cursor-not-allowed">
				Confirm Withdrawal Address
			</button>
		</div>
	</div>
</template>

<script setup>
	import { ref, watch } from 'vue';
	import lightX from '../assets/X.png';
	import darkX from '../assets/XWhite.png';
	import plusLight from '../assets/PlusLightTheme.png';
	import plusDark from '../assets/PlusDarkTheme.png';

	const props = defineProps({
		currentTheme: { type: String, required: true },
		evmAccounts: { type: Array,  required: true },
		initialSelected: { type: Object, default: null }
	});

	const emit = defineEmits([
		'close',
		'confirm-withdrawal-address',
		'select-account',
		'add-account'
	]);

	const open = ref(false);
	const selected = ref(props.initialSelected);


	watch(() => props.initialSelected, v => {
		selected.value = v;
	});

	function toggle() { 
		open.value = !open.value; 
	}

	function select(a) {
		selected.value = a;
		open.value = false;
		emit('select-account', a);
	}

	function add() {
		open.value = false;
		emit('add-account');
	}

	function abbr(addr) {
		return addr.slice(0, 6) + '...' + addr.slice(-4);
	}
</script>

<style scoped>
	.popup-bg {
		background: var(--popup-bg-color);
	}
	.fade-enter-active, .fade-leave-active {
		transition: opacity .2s ease;
	}
	.fade-enter-from, .fade-leave-to {
		opacity: 0;
	}
</style>
